module.exports = __webpack_public_path__ + "img/contact_qq.aaa8b143.png";